module.exports = __webpack_public_path__ + "img/background.7d178134.jpeg";